// @flow
import * as React from 'react';
import classnames from '@ta/common.classnames';
import { Icon } from '@ta/styleguide.icon';
import { Link } from '@ta/common.routing';
import styles from './UrlDomain.less';

type Props = {|
  domain: string,
  url?: string,
  className?: string,
|};

const UrlDomain = ({ domain, url, className }: Props) =>
  React.createElement(
    url ? Link : 'span',
    { className: classnames(className, 'ui_link'), href: url },
    <>
      {domain}
      <Icon name="external-link-no-box" className={styles.icon} />
    </>,
  );

/** The MentionTitle component */
export default React.memo<Props>(UrlDomain);
